module.exports = __webpack_public_path__ + "img/img4.f003f0ad.jpg";